<template>
  <div>
    <v-container class="mt-16" fluid>
      <v-expansion-panels>
        <v-expansion-panel>
          <v-expansion-panel-header>
            FILTROS
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-row>
              <v-col xl="2" md="6" lg="2" cols="12">
                <v-menu
                  v-model="menuRangoFechas"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      dense
                      style="height: 55px;"
                      clearable
                      v-model="rangoDeFechas"
                      label="Elija un rango de fechas"
                      prepend-icon="mdi-calendar"
                      readonly
                      @input="realizaBusqueda()"
                      v-bind="attrs"
                      v-on="on"
                      outlined
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    range
                    v-model="rangoDeFechas"
                    @input="
                      checarSiHayQueCerrarRango();
                      realizaBusqueda();
                    "
                  ></v-date-picker>
                </v-menu>
              </v-col>

              <v-col xl="2" md="6" lg="2" cols="12">
                <v-select
                  style="height: 70px;"
                  dense
                  v-model="busqueda.tipoServicio"
                  item-text="texto"
                  item-value="valor"
                  :items="[
                    { texto: 'Mensajeria', valor: '1' },
                    { texto: 'Paqueteria', valor: '2' },
                    { texto: 'Todos', valor: '' }
                  ]"
                  @input="realizaBusqueda()"
                  label="Tipo de Servicio"
                  outlined
                ></v-select>
              </v-col>
              <v-col xl="2" md="6" lg="2" cols="12">
                <v-select
                  dense
                  style="height: 70px;"
                  v-model="busqueda.detalleEnvio"
                  item-text="texto"
                  item-value="valor"
                  :items="[
                    { texto: 'Nacional Dia siguiente', valor: '3' },
                    { texto: 'Nacional Terrestre', valor: '4' },
                    { texto: 'Nacional Regional', valor: '5' },
                    { texto: 'Todos', valor: '' }
                  ]"
                  @input="realizaBusqueda()"
                  label="Detalle envio"
                  outlined
                ></v-select>
              </v-col>
              <v-col xl="2" md="6" lg="2" cols="12">
                <v-select
                  dense
                  style="height: 70px;"
                  v-model="busqueda.estado"
                  item-text="texto"
                  item-value="valor"
                  :items="[
                    { texto: 'Pagado', valor: '1' },
                    { texto: 'No pagado', valor: '0' },
                    { texto: 'Cancelado', valor: '2' },
                    { texto: 'Todos', valor: '' }
                  ]"
                  @input="realizaBusqueda()"
                  label="Estado envio"
                  outlined
                ></v-select>
              </v-col>
              <v-col xl="2" md="6" lg="2" cols="12">
                <v-select
                  style="height: 70px;"
                  clearable
                  dense
                  v-model="busqueda.sucursal"
                  :items="sucursalesList"
                  item-text="NOMBRE"
                  item-value="ID"
                  @input="realizaBusqueda()"
                  label="Sucursal"
                  outlined
                ></v-select>
              </v-col>
              <v-col xl="2" md="6" lg="2" cols="12">
                <v-text-field
                  outlined
                  dense
                  v-model="busqueda.guiaFedex"
                  label="Guia fedex"
                  @input="realizaBusqueda()"
                  hide-details
                  clearable
                ></v-text-field>
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <v-row>
        <v-col cols="0" md="1"></v-col>
        <v-col cols="12" md="2">
          <v-alert dense text color="green"
            >Total envíos: {{ formateaMoneda(totalesVeconaL.Tenvios) }}</v-alert
          >
        </v-col>
        <v-col cols="12" md="2">
          <v-alert dense text color="green"
            >Total abonos clientes: {{ formateaMoneda(totalesVeconaL.Tpagado) }}</v-alert
          >
        </v-col>
        <v-col cols="12" md="2">
          <v-alert dense text color="green"
            >Total deuda clientes: {{ formateaMoneda(totalesVeconaL.Tdeuda) }}</v-alert
          >
        </v-col>
        <v-col cols="12" md="2">
          <v-alert dense text color="green"
            >Total Fedex: {{ formateaMoneda(totalesVeconaL.Tfedex) }}</v-alert
          >
        </v-col>
        <v-col cols="12" md="2">
          <v-alert dense text color="green"
            >Ganancia total: {{ formateaMoneda(totalesVeconaL.Tganancia) }}</v-alert
          >
        </v-col>
        <v-col cols="0" md="1"></v-col>
      </v-row>
      <v-row style="margin-top:-15px;">
        <v-col>
          <v-card>
            <v-card-title>
              VECONA
              <v-spacer></v-spacer>
              <v-col cols="12" md="6" lg="2" xl="2">
                <v-text-field
                  dense
                  v-model="busqueda.referencia"
                  label="Referencia"
                  @input="realizaBusqueda()"
                  hide-details
                  clearable
                  outlined
                  autocomplete="new"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6" lg="2" xl="2">
                <v-text-field
                  outlined
                  dense
                  v-model="busqueda.remitente"
                  label="Remitente"
                  @input="realizaBusqueda()"
                  hide-details
                  autocomplete="new"
                  clearable
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6" lg="2" xl="2">
                <v-text-field
                  outlined
                  dense
                  v-model="busqueda.destinatario"
                  label="Destinatario"
                  @input="realizaBusqueda()"
                  hide-details
                  clearable
                  autocomplete="new"
                ></v-text-field>
              </v-col>
              <v-col md="6" cols="12" lg="2" xl="2">
                <v-select
                  style="margin-bottom:-26px !important;"
                  dense
                  :items="[5, 10, 15, 50]"
                  label="Elementos por página"
                  v-model="regPag"
                  outlined
                  @input="realizaBusqueda()"
                ></v-select>
              </v-col>
            </v-card-title>

            <v-data-table
              style="text-overflow: ellipsis;"
              :loading="tableLoading"
              loading-text="Cargando... por favor espere."
              :headers="headers"
              :items="veconaL"
              :items-per-page="regPag"
              hide-default-footer
              item-key="REFERENCIA"
              single-expand
              show-expand
              :item-class="clasesRenglones"
            >
              <!-- v-bind:class="{ active: isActive, 'text-danger': hasError }"> -->
              <template #item.actions="{ item }">
                <v-btn
                  v-if="item.ESTADO != 'Pagado' && item.ESTADO != 'Cancelado'"
                  @click="realizarAbonoEnvio(item.REFERENCIA, item.ABONOS)"
                  :color="getColorBotonAbonos(item.EXTRA)"
                  text
                  rounded
                  dark
                >
                  AB.
                  <v-icon small>
                    mdi-cash-multiple
                  </v-icon>
                </v-btn>
              </template>
              <template v-slot:expanded-item="{ headers, item }">
                <td :colspan="headers.length">
                  <Detalles :itemi="item" />
                </td>
              </template>
              <template #item.totalDeuda="{ item }">
                <div style="color:red;font-weight:bold;" v-if="item.ESTADO == 'Cancelado'">
                  CANC.
                </div>
                <div v-else style="font-weight:bold;">{{ formateaMoneda(item.ABONOS.total) }}</div>
              </template>
              <template style="font-weight:bold;" #item.importePagado="{ item }">
                <div style="color:red;font-weight:bold;" v-if="item.ESTADO == 'Cancelado'"></div>
                <div style="font-weight:bold;" v-else>
                  {{
                    formateaMoneda(parseFloat(item.ABONOS.total - calculaDeudaActual(item.ABONOS)))
                  }}
                </div>
              </template>
              <template #item.deudaactual="{ item }">
                <div style="color:red;font-weight:bold;" v-if="item.ESTADO == 'Cancelado'"></div>
                <div style="font-weight:bold;" v-else>
                  {{ formateaMoneda(calculaDeudaActual(item.ABONOS)) }}
                </div>
              </template>
              <template #item.balanceChido="{ item }">
                <div style="color:red;font-weight:bold;" v-if="item.ESTADO == 'Cancelado'"></div>
                <div style="font-weight:bold;" v-else>
                  <v-chip color="green" dark v-if="item.EXTRA.balance >= 0">{{
                    item.EXTRA.balance
                  }}</v-chip>
                  <v-chip color="orange"  dark v-if="item.EXTRA.balance < 0">{{
                    Math.abs(item.EXTRA.balance)
                  }}</v-chip>
                  <!-- {{ formateaMoneda(calculaDeudaActual(item.ABONOS)) }} -->
                </div>
              </template>
              <template #item.diferenciaKilosChido="{ item }">
                <div style="color:red;font-weight:bold;" v-if="item.ESTADO == 'Cancelado'"></div>
                <div style="font-weight:bold;" v-else>
                  <v-chip color="green" dark v-if="item.EXTRA.dif >= 0">{{
                    item.EXTRA.dif
                  }}</v-chip>
                  <v-chip color="orange"  dark v-if="item.EXTRA.dif < 0">{{
                    Math.abs(item.EXTRA.dif)
                  }}</v-chip>
                  <!-- {{ formateaMoneda(calculaDeudaActual(item.ABONOS)) }} -->
                </div>
              </template>
              <template #item.conciliacionCostoEnvio="{ item }">
                <div style="display:flex;" v-if="item.ESTADO != 'Cancelado'">
                  <v-text-field
                    :ref="'inputCostoFedex' + item.REFERENCIA"
                    autocomplete="new"
                    @focus="$event.target.select()"
                    v-model="item.COSTO_FEDEX"
                    @input="hacerConciliacion(item.REFERENCIA)"
                    style="width:100%;margin-top:6px; align-self:center;"
                    solo
                    dense
                  ></v-text-field>
                </div>
              </template>
              <template #item.conciliacionPesoCobrado="{ item }">
                <div style="display:flex;" v-if="item.ESTADO != 'Cancelado'">
                  <v-text-field
                    :ref="'inputPesoFedex' + item.REFERENCIA"
                    :id="'inputPesoFedex' + item.REFERENCIA"
                    @focus="$event.target.select()"
                    v-model="item.KG_FEDEX"
                    @input="hacerConciliacion(item.REFERENCIA)"
                    style="width:100%;margin-top:6px;align-self:center;"
                    solo
                    dense
                  ></v-text-field>
                </div>
              </template>
            </v-data-table>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="3"> </v-col>
        <v-col cols="6">
          <v-pagination
            @input="realizaBusqueda(0)"
            v-model="pag"
            :length="totalPaginas"
          ></v-pagination>
        </v-col>
        <v-col cols="3"> </v-col>
      </v-row>
    </v-container>
    <v-snackbar
      v-model="snackbarHistorialEnvios"
      timeout="2000"
      rounded="pill"
      centered
      elevation="8"
      :color="colorSnackbar"
      ><span style="font-size:20px;">
        {{ msgsnackbarHistorialEnvios }}
      </span></v-snackbar
    >
    <AbonoEnvio
      @muestraMensaje="muestraAlertaEvento($event)"
      :idAbono="idAbonoModal"
      @cerrar-modal-abono-envio="modalAbonos = false"
      :mostrarAbonoEnvio="modalAbonos"
      :saldoEnvio="deudaUnSoloAbono"
      v-if="modalAbonos"
    />
  </div>
</template>

<script>
import { FormatoMoneda, FormatoGuia } from "@/Utils/Utils";
import Detalles from "@/components/DetallesVECO.vue";
import AbonoEnvio from "@/components/AbonoEnvio.vue";
import _ from "lodash";
import moment from "moment";
import { mapActions, mapState } from "vuex";
export default {
  components: {
    AbonoEnvio,
    Detalles
  },
  data: () => ({
    rangoFechaHabilActual: [],
    snackbarHistorialEnvios: false,
    colorSnackbar: "",
    msgsnackbarHistorialEnvios: "",
    modalAbonos: false,
    menuRangoFechas: false,
    rangoDeFechas: [],
    tableLoading: false,
    pag: 2,
    regPag: 10,
    totalPaginas: 0,
    busqueda: {
      referencia: "",
      remitente: "",
      destinatario: "",
      tipoServicio: "",
      detalleEnvio: "",
      sucursal: "",
      guiaFedex: "",
      fechaInicio: "",
      fechaFin: "",
      estado: ""
    },
    headers: [
      { text: "", value: "data-table-expand" },
      {
        text: "Referencia",
        align: "center",
        sortable: false,
        value: "REFERENCIA",
        width: 30
      },
      {
        text: "Fecha",
        align: "center",
        sortable: false,
        value: "FECHA"
      },
      {
        text: "Cliente",
        align: "center",
        sortable: false,
        value: "REMITENTE.nombre"
      },
      {
        text: "Destinatario",
        align: "center",
        sortable: false,
        value: "DESTINATARIO.nombre"
      },
      {
        text: "Tipo de servicio",
        align: "center",
        sortable: false,
        value: "TIPO_SERVICIO"
      },
      {
        text: "Detalle envío",
        align: "center",
        sortable: false,
        value: "DETALLE_ENVIO"
      },
      {
        text: "Sucursal",
        align: "center",
        sortable: false,
        value: "SUCURSAL"
      },
      {
        text: "Total envío",
        align: "center",
        sortable: false,
        value: "totalDeuda"
      },
      {
        text: "Total pagado",
        align: "center",
        sortable: false,
        value: "importePagado"
      },

      {
        text: "Saldo actual",
        align: "center",
        sortable: false,
        value: "deudaactual"
      },
      {
        text: "DIF.",
        align: "center",
        sortable: false,
        value: "diferenciaKilosChido",
      },
      {
        text: "Balance",
        align: "center",
        sortable: false,
        value: "balanceChido",
      },
      {
        text: "Conc. Costo",
        align: "center",
        sortable: false,
        value: "conciliacionCostoEnvio",
        width: 90
      },
      {
        text: "Conc. Kg.",
        align: "center",
        sortable: false,
        value: "conciliacionPesoCobrado",
        width: 90
      },
      {
        text: "",
        align: "center",
        sortable: false,
        value: "actions",
        width: 90
      },
      { text: "", value: "data-table-expand" }
    ]
  }),
  async beforeDestroy() {
    await this.destroyVecona();
  },
  methods: {
    ...mapActions("vecona", [
      "getVecona",
      "destroyVecona",
      "updateConciliacion",
      "getTotalesVecona"
    ]),
    ...mapActions("sucursales", ["getSucursales"]),
    ...mapActions("usuarios", ["getUsuarios"]),
    ...mapActions("cuentas", ["getCuentas"]),
    getColorBotonAbonos(item) {
      if (item.ganancia < 0) {
        return "white";
      } else {
        return "green";
      }
    },
    clasesRenglones(item) {
      if (item.ESTADO != "Cancelado") {
        if (item.EXTRA.ganancia < 0) {
          return "red lighten-2 font-weight-black white--text";
        }
      }
    },
    delayRealizaBusqueda: _.debounce(async function(ref) {
      await this.realizaBusqueda();
    }, 10),
    hacerConciliacion: _.debounce(async function(ref) {
      if (
        this.$refs[`inputPesoFedex${ref}`].value != 0 &&
        this.$refs[`inputCostoFedex${ref}`].value != 0
      ) {
        const res = await this.updateConciliacion({
          idenvio: ref,
          kg_fedex: this.$refs[`inputPesoFedex${ref}`].value,
          costo_fedex: this.$refs[`inputCostoFedex${ref}`].value
        });
        if (res[0]) {
          this.realizaBusqueda();
          this.msgsnackbarHistorialEnvios = "Conciliación exitosa Envío #" + ref;
          this.colorSnackbar = "blue";
          this.snackbarHistorialEnvios = true;
        }
      }
    }, 500),
    formateaMoneda(moneda) {
      return FormatoMoneda.format(moneda);
    },
    calculaTotalDeuda(total) {
      // let pagosHechos = 0;
      // for (var i = 0; i < total.Abonos.length; i++) {
      //   pagosHechos += parseFloat(total.Abonos[i].cantidad);
      // }
      // const totalDeuda = parseFloat(total.total) - parseFloat(pagosHechos);
      return total;
    },
    async muestraAlertaEvento(evento) {
      if (evento == "abonoCorrecto") {
        this.modalAbonos = false;
        this.snackbarHistorialEnvios = true;
        this.msgsnackbarHistorialEnvios = "Abono correctamente realizado";
        this.colorSnackbar = "blue darken-1";
      } else if (evento == "envioprevpagado") {
        this.modalAbonos = false;
        this.snackbarHistorialEnvios = true;
        this.msgsnackbarHistorialEnvios =
          "El envio ya está completamente pagado, no es posible realizar otro abono.";
        this.colorSnackbar = "red darken-1";
      }
      this.realizaBusqueda();
    },
    async realizarAbonoEnvio(referencia, abonos) {
      const deudaEnvioEspecifico = await this.calculaDeudaActual(abonos);
      this.deudaUnSoloAbono = deudaEnvioEspecifico;
      this.idAbonoModal = referencia;
      this.modalAbonos = true;
    },
    calculaDeudaActual(abonos) {
      let pagosHechos = 0;
      for (var i = 0; i < abonos.Abonos.length; i++) {
        pagosHechos += parseFloat(abonos.Abonos[i].cantidad);
      }
      const deudaActual = parseFloat(abonos.total) - parseFloat(pagosHechos);
      return deudaActual;
    },
    calculaDeudaActual(abonos) {
      let pagosHechos = 0;
      for (var i = 0; i < abonos.Abonos.length; i++) {
        pagosHechos += parseFloat(abonos.Abonos[i].cantidad);
      }
      const deudaActual = parseFloat(abonos.total) - parseFloat(pagosHechos);
      return deudaActual;
    },
    checarSiHayQueCerrarRango() {
      if (this.rangoDeFechas[1]) {
        this.menuRangoFechas = false;
        this.realizaBusqueda();
      }
    },
    realizaBusqueda: _.debounce(async function(pagi = 1) {
      if (this.rangoDeFechas == null) {
        this.rangoDeFechas = [];
      }
      if (pagi == 1) {
        this.pag = 1;
      }
      this.tableLoading = true;
      const res = await this.getVecona({
        pag: this.pag,
        regPag: this.regPag,
        referencia: this.referenciaEdit,
        remitente: this.remitenteEdit,
        destinatario: this.destinatarioEdit,
        tipoServicio: this.tipoServicioEdit,
        detalleEnvio: this.detalleEnvioEdit,
        sucursal: this.sucursalEdit,
        guiaFedex: this.guiaFEDEXEdit,
        fechaInicio: this.rangoFechaInicial,
        fechaFin: this.rangoFechaFinal,
        estado: this.estadoEdit
      });
      if (pagi != 0) {
        const res2 = await this.getTotalesVecona({
          referencia: this.referenciaEdit,
          remitente: this.remitenteEdit,
          destinatario: this.destinatarioEdit,
          tipoServicio: this.tipoServicioEdit,
          detalleEnvio: this.detalleEnvioEdit,
          sucursal: this.sucursalEdit,
          guiaFedex: this.guiaFEDEXEdit,
          fechaInicio: this.cualFechaInicialRetornar,
          fechaFin: this.cualFechaFinalRetornar,
          estado: this.estadoEdit
        });
      }
      if (res[0]) {
        this.totalPaginas = res[1];
      }
      // this.totalPaginas
      this.tableLoading = false;
    }, 400)
  },
  async mounted() {
    this.rangoFechaHabilActual = [
      moment()
        .weekday(0)
        .format("L"),
      moment()
        .weekday(6)
        .format("L")
    ];
    // this.rangoDeFechas = [
    //   moment()
    //     .subtract(7, "days")
    //     .format("YYYY-MM-DD"),
    //   moment().format("YYYY-MM-DD")
    // ];
    await this.getSucursales();
    await this.realizaBusqueda();
  },
  computed: {
    cualFechaInicialRetornar() {
      if (this.rangoDeFechas.length == 2) {
        return this.rangoFechaInicial;
      } else {
        return `&fecha_inicio=${this.rangoFechaHabilActual[0]}`;
      }
    },
    cualFechaFinalRetornar() {
      if (this.rangoDeFechas.length == 2) {
        return this.rangoFechaFinal;
      } else {
        return `&fecha_fin=${this.rangoFechaHabilActual[1]}`;
      }
    },
    ...mapState("vecona", {
      veconaL: state => state.vecona,
      totalesVeconaL: state => state.totalesVecona
    }),
    ...mapState("sucursales", {
      sucursalesList: state => state.sucursales
    }),
    ...mapState("usuarios", {
      usuariosL: state => state.listUsuarios
    }),
    ...mapState("cuentas", {
      cuentasList: state => state.cuentas
    }),
    usuariosNombresApellidos() {
      let chale = [];
      for (var i = 0; i < this.usuariosL.length; i++) {
        chale.push(
          this.usuariosL[i].NOMBRE +
            " " +
            this.usuariosL[i].APELLIDO_P +
            " " +
            this.usuariosL[i].APELLIDO_M
        );
      }
      return chale;
    },
    rangoFechaInicial() {
      return this.rangoDeFechas.length == 2
        ? `&fecha_inicio=${moment(this.rangoDeFechas[0]).format("L")}`
        : "";
    },
    rangoFechaFinal() {
      return this.rangoDeFechas.length == 2
        ? `&fecha_fin=${moment(this.rangoDeFechas[1]).format("L")}`
        : "";
    },
    referenciaEdit() {
      return this.busqueda.referencia == "" || this.busqueda.referencia == null
        ? ""
        : `&referencia=${this.busqueda.referencia}`;
    },
    remitenteEdit() {
      return this.busqueda.remitente == "" || this.busqueda.remitente == null
        ? ""
        : `&remitente=${this.busqueda.remitente}`;
    },
    destinatarioEdit() {
      return this.busqueda.destinatario == "" || this.busqueda.destinatario == null
        ? ""
        : `&destinatario=${this.busqueda.destinatario}`;
    },
    tipoServicioEdit() {
      return this.busqueda.tipoServicio == "" || this.busqueda.tipoServicio == null
        ? ""
        : `&tipo_servicio=${this.busqueda.tipoServicio}`;
    },
    detalleEnvioEdit() {
      return this.busqueda.detalleEnvio == "" || this.busqueda.detalleEnvio == null
        ? ""
        : `&detalle_envio=${this.busqueda.detalleEnvio}`;
    },
    sucursalEdit() {
      return this.busqueda.sucursal == "" || this.busqueda.sucursal == null
        ? ""
        : `&sucursal=${this.busqueda.sucursal}`;
    },
    guiaFEDEXEdit() {
      return this.busqueda.guiaFedex == "" || this.busqueda.guiaFedex == null
        ? ""
        : `&guia_fedex=${this.busqueda.guiaFedex}`;
    },
    estadoEdit() {
      return this.busqueda.estado == "" || this.busqueda.estado == null
        ? ""
        : `&estado=${this.busqueda.estado}`;
    },
    fechaInicioEdit() {
      return this.busqueda.fechaInicio == "" || this.busqueda.fechaInicio == null
        ? ""
        : `&fecha_inicio=${this.busqueda.fechaInicio}`;
    },
    fechaFinEdit() {
      return this.busqueda.fechaFin == "" || this.busqueda.fechaFin == null
        ? ""
        : `&fecha_fin=${this.busqueda.fechaFin}`;
    }
  }
};
</script>
